import { useCallback, useState } from 'react';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import { useDynamicFieldsStorage } from './useDynamicFieldsStorage';
import { SCHEMA_STORAGE_KEY } from '../services/SchemaService';
import { THEME_STORAGE_KEY } from 'utils/ThemeService';

export const useComplementaryModule = () => {
  const { updateStorageData } = useDynamicFieldsStorage();
  const [isModuleLoaded, setIsModuleLoaded] = useState(false);
  const [moduleData, setModuleData] = useState(null);

  const handleModuleDataUpdate = useCallback((data: any) => {
    console.log('Dados recebidos do módulo complementary:', data);
    
    if (data.complementaryInfo) {
      updateStorageData('complementaryInfo', data.complementaryInfo);
    }
    
    ApiLocalStorage.set('complementaryStep', data.complementaryInfo);
    
    setModuleData(data);
  }, [updateStorageData]);

  const getComplementaryProps = useCallback(() => {
    const registrationData = ApiLocalStorage.get('registrationData') || {};
    const schemaData = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
    const theme = ApiLocalStorage.get(THEME_STORAGE_KEY);
    
    return {
      userData: registrationData,
      schemaData,
      theme,
      currentStep: 'complementary',
      totalSteps: 6,
      onDataUpdate: handleModuleDataUpdate,
      onModuleLoad: () => setIsModuleLoaded(true),
      onModuleError: (error: any) => {
        console.error('Erro no módulo complementary:', error);
        setIsModuleLoaded(false);
      }
    };
  }, [handleModuleDataUpdate]);

  const isComplementaryStepRequired = useCallback(() => {
    const schemaData = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
    return schemaData?.complementaryStepAfterOnboarding?.formFields?.length > 0;
  }, []);

  return {
    isModuleLoaded,
    moduleData,
    getComplementaryProps,
    isComplementaryStepRequired,
    handleModuleDataUpdate
  };
}; 